import React from 'react';

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export default function VegaIcon({ name, className = 'w-5 h-5' }) {
  switch (name) {
    case 'spark':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><path d="M12 3v4M12 17v4M3 12h4M17 12h4M5.6 5.6l2.8 2.8M15.6 15.6l2.8 2.8M5.6 18.4l2.8-2.8M15.6 8.4l2.8-2.8"/></svg>;
    case 'fleet':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><rect x="3" y="4" width="18" height="6" rx="1.5"/><rect x="3" y="14" width="18" height="6" rx="1.5"/><circle cx="6.5" cy="7" r=".8" fill="currentColor"/><circle cx="6.5" cy="17" r=".8" fill="currentColor"/></svg>;
    case 'store':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><path d="M3 8l1.5-4h15L21 8M3 8h18M3 8v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V8M9 12h6"/></svg>;
    case 'code':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><path d="M8 7l-5 5 5 5M16 7l5 5-5 5M14 4l-4 16"/></svg>;
    case 'check':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><path d="M5 12.5l4.5 4.5L19 7"/></svg>;
    case 'arrow':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><path d="M5 12h14M13 6l6 6-6 6"/></svg>;
    case 'plus':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><path d="M12 5v14M5 12h14"/></svg>;
    case 'chevron':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><path d="M6 9l6 6 6-6"/></svg>;
    case 'atlas':
      return <svg viewBox="0 0 24 24" className={className} {...stroke}><path d="M20 7l-8-4-8 4 8 4 8-4zM4 7v10l8 4M20 7v10l-8 4M12 11v10"/></svg>;
    default:
      return null;
  }
}
